import React from 'react';
import { Notification } from './Notification';
import { assign } from 'lodash';

export const getNotification =

  (type) =>

    /** @type {GetNotificationViewData} */
      ({ title, message, additionalViewData = {} }, t) => {

      const notificationViewData = assign({}, getNotification.defaultOptions, additionalViewData);

      const { linkUrl, linkMessage } = additionalViewData;
      notificationViewData.content = (
        <Notification
          t={t}
          type={type}
          message={message}
          title={title}
          linkUrl={linkUrl}
          linkMessage={linkMessage}
        >
          { additionalViewData.content && additionalViewData.content }
        </Notification>
      );

      return notificationViewData;
    };

getNotification.defaultOptions = {
  closable: true,
  style: { right: 10 }
};
